
import {
  POST,
  GET,
} from '@/axios/axios'

export const services = {
  UserLogin: (param) => {   // 登录
    return POST('/merchant/user/login', param)
  },
  getCashCode: (param) => {   // 获取验证码
    return GET('/merchant/sendMessage/getSignInCode', param)
  },
  AmendPassword: (param) => {   // 修改登录密码
    return POST('/merchant/user/updatePassword', param)
  },
  LoginCode: () => { // 登录验证码使用
    return GET("/merchant/sendMessage/getVerifyCodeImage");
  },
  LogOut: () => { // 退出登录
    return GET("/merchant/user/loginOut");
  },
  HomePageDatiles: (param) => {   // 首页
    return GET('/merchant/custom/getMerchantIndexInfo', param)
  },
  CommercialTenant: (param) => {   // 查询商户信息
    return GET('/merchant/custom/customInfo', param)
  },
  SidebarList: (param) => {  // 侧边导航
    return GET('/merchant/role/getMenu', param)
  },
  getBtnList: (param) =>{ // 获取按钮
    return GET("/merchant/role/getButton", param);
  },
  PayPassWord: (param) => { // 修改支付密码
    return POST('/merchant/custom/updatePayPassword', param)
  },
  dataDictByPara: (param) => { // 获取后台设置开关
    return GET('/merchant/dataDict/findDataDictByParaValue10', param)
  },
  PlatformSetting: (param) => { // 平台设置列表
    return GET('/merchant/custom/queryPlatformList', param)
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/user.js